import { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';

const DEFAULT_FEE_RATE = 5;

let cachedFeeRate: number | null = null;

export const usePlatformFeeRate = (): number => {
  const [feeRate, setFeeRate] = useState<number>(cachedFeeRate ?? DEFAULT_FEE_RATE);

  useEffect(() => {
    if (cachedFeeRate != null) return;

    let cancelled = false;
    apiClient
      .get('/platform-setting/fee-rate')
      .then((res) => {
        if (cancelled) return;
        const rate = Number(res.data?.data?.feeRate ?? DEFAULT_FEE_RATE);
        cachedFeeRate = rate;
        setFeeRate(rate);
      })
      .catch(() => {
        // Fallback to default — not critical for display
      });

    return () => { cancelled = true; };
  }, []);

  return feeRate;
};
